import React, { useState } from 'react'

const AlertPhones = ({alertPhones, onAddPhone, onDeletePhone}) => {
  const [alertPhone, setAlertPhone] = useState()

  const handlePhoneAdded = () => {
    onAddPhone(alertPhone)
    setAlertPhone('')
  }

  return (
    <div className='col-lg-4 col-md-6 admin-alerts-phones'>
      <label>Phones</label>
      <ul>
        { alertPhones && alertPhones.map((phone, index) => {
          return (
            <li key={index}>
              <div className='form-group admin-alerts-input'>
                <a onClick={() => onDeletePhone(phone)} className='admin-alerts__minus'>—</a>
                <input className='form-control' type='text' value={phone} disabled={true} />
              </div>
            </li>
          )
        })}
        <div className='form-group admin-alerts-input'>
          <input onChange={(e) => setAlertPhone(e.target.value)} value={alertPhone} className='form-control' type='text' />
          <button onClick={handlePhoneAdded} className='btn btn-success mt-2'>Add</button>
        </div>
      </ul>
    </div>
  )
}

export default AlertPhones
